// extracted by mini-css-extract-plugin
export var emailBlockLink = "_j1-0";